import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import API from "utils/API";

const CoveredEntity = ({ thirdPartyAdminID, selectedCE, onSelect }) => {
  const [ceName, setCEName] = useState("");
  const [ceOpt, setCEOpt] = useState([]);
  const [ceLoading, setCELoading] = useState(false);

  useEffect(() => {
    if (ceOpt.length && !selectedCE) {
      setCEOpt([]);
    }
  }, [selectedCE]);

  const handleChangeCE = async (value) => {
    setCEName(value);
    if (thirdPartyAdminID === null || thirdPartyAdminID === undefined || !value) return null;
    if (value && value.length < 3) {
      return null;
  }
    setCELoading(true);
    try {
      const result = await API.post(`GWConfig/AutoSearch/CoveredEntity/${value}`,thirdPartyAdminID,{
        hasDefaultURL: true,
        hideLoader: true,
    });
      if (result?.data?.length > 0) {
        setCEOpt(result.data);
        setCELoading(false);
      } else {
        setCEOpt([]);
        setCELoading(false);
      }
    } catch (error) {
      setCELoading(false);
    }
  };

  const onSelectCE = (entity) => {
    onSelect(entity);
  };

  return (
    <Select
      className="form-field-large inner-shadow-field"
      classNamePrefix="select"
      IndicatorSeparator
      isSearchable={true}
      isLoading={ceLoading}
      placeholder="Enter OPAID Or CE Name"
      name="color"
      options={ceOpt}
      isClearable={true}
      inputValue={ceName}
      value={selectedCE}
      onInputChange={handleChangeCE}
      onChange={onSelectCE}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
    />
  );
};

export default CoveredEntity;
